import { useEffect, useState } from "react";
import { useRouterState } from "@tanstack/react-router";
import { useShellHost } from "@/shell-handle/ShellHostProvider";
import { Toolbar } from "@/shared/components/toolbar/toolbar";
import { ShellSitesContextProvider } from "@/shared/context/Sites";
import { metaForPath } from "@/single-spa-config/toolbarMeta";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import type { IconDefinition } from "@fortawesome/fontawesome-common-types";
import type { PageMeta } from "@observe-tech/mfe-shell-api";

export function ShellToolbar() {
  const host = useShellHost();
  const { location } = useRouterState();
  const [meta, setMeta] = useState<PageMeta>(host.handle.pageMeta.meta.get());

  useEffect(
    () =>
      host.handle.pageMeta.meta.subscribe(() =>
        setMeta(host.handle.pageMeta.meta.get()),
      ),
    [host],
  );

  const route = metaForPath(location.pathname);
  if (route?.hide) return null;

  const title = meta.title || route?.title || "";
  const icon: IconDefinition = route?.icon ?? faGlobe;
  const withDates =
    meta.title && meta.withDates !== undefined
      ? meta.withDates
      : (route?.withDates ?? meta.withDates ?? false);
  const hideSitePicker =
    meta.title && meta.hideSitePicker !== undefined
      ? meta.hideSitePicker
      : (route?.hideSitePicker ?? meta.hideSitePicker ?? false);
  const isSingleSite =
    meta.title && meta.isSingleSite !== undefined
      ? meta.isSingleSite
      : (route?.isSingleSite ?? meta.isSingleSite ?? false);

  return (
    <ShellSitesContextProvider>
      <Toolbar
        icon={icon}
        title={title}
        withDates={withDates}
        hideSitePicker={hideSitePicker}
        isSingleSite={isSingleSite}
      />
    </ShellSitesContextProvider>
  );
}
